import "@/App.css";
import { SmoothScroll } from "@/components/brook/SmoothScroll";
import { Nav } from "@/components/brook/Nav";
import { Hero } from "@/components/brook/Hero";
import { OurStory } from "@/components/brook/OurStory";
import { TheRiver } from "@/components/brook/TheRiver";
import { TheSpace } from "@/components/brook/TheSpace";
import { TheFood } from "@/components/brook/TheFood";
import { DroneVideo } from "@/components/brook/DroneVideo";
import { Amenities } from "@/components/brook/Amenities";
import { Events } from "@/components/brook/Events";
import { Gallery } from "@/components/brook/Gallery";
import { Reviews } from "@/components/brook/Reviews";
import { Instagram } from "@/components/brook/Instagram";
import { Contact } from "@/components/brook/Contact";
import { Footer } from "@/components/brook/Footer";
import { StickyWhatsApp } from "@/components/brook/StickyWhatsApp";

function App() {
  return (
    <SmoothScroll>
      <div className="App grain bg-[#fbf8f0] overflow-x-hidden">
        <Nav />
        <main>
          <Hero />
          <OurStory />
          <TheRiver />
          <TheSpace />
          <TheFood />
          <DroneVideo />
          <Amenities />
          <Events />
          <Gallery />
          <Reviews />
          <Instagram />
          <Contact />
        </main>
        <Footer />
        <StickyWhatsApp />
      </div>
    </SmoothScroll>
  );
}

export default App;
